module.exports = "<header>\r\n  <div class=\"header-content\"><h1>BotDetect Angular CAPTCHA Examples</h1></div>\r\n</header>\r\n\r\n<nav>\r\n  <ul class=\"nav\">\r\n    <li><a routerLink=\"/basic\" routerLinkActive=\"active\">Basic Example</a></li>\r\n    <li><a routerLink=\"/contact\" routerLinkActive=\"active\">Contact Example</a></li>\r\n  </ul>\r\n</nav>\r\n\r\n<section id=\"main-content\">\r\n  <router-outlet></router-outlet>\r\n</section>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main